import { useState } from "react";
import { CONTACT } from "../data/site";
import { MessageCircle, X, Phone, Mail } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

export function WhatsAppButton() {
  const [open, setOpen] = useState(false);
  const waLink = `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent("Hi Kerala Holidays Connect! I'd like to plan a Mumbai to Kerala tour.")}`;

  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col items-end gap-3" data-testid="floating-contact">
      <AnimatePresence>
        {open && (
          <motion.div initial={{ opacity: 0, y: 10, scale: 0.95 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, y: 10, scale: 0.95 }}
            className="bg-cream shadow-2xl border border-emerald/10 w-64 overflow-hidden" data-testid="chat-widget">
            <div className="bg-emerald text-cream p-4">
              <p className="font-serif text-lg">Chat with us</p>
              <p className="text-cream/70 text-xs">Typically replies within minutes</p>
            </div>
            <div className="p-3 flex flex-col gap-2">
              <a href={waLink} target="_blank" rel="noreferrer" data-testid="widget-whatsapp" className="flex items-center gap-3 p-3 hover:bg-emerald/5 transition-colors text-sm">
                <MessageCircle className="w-5 h-5 text-emerald" /> WhatsApp Now
              </a>
              <a href={`tel:${CONTACT.phoneRaw}`} data-testid="widget-call" className="flex items-center gap-3 p-3 hover:bg-emerald/5 transition-colors text-sm">
                <Phone className="w-5 h-5 text-emerald" /> Call {CONTACT.phone}
              </a>
              <a href={`mailto:${CONTACT.email}`} data-testid="widget-email" className="flex items-center gap-3 p-3 hover:bg-emerald/5 transition-colors text-sm">
                <Mail className="w-5 h-5 text-emerald" /> Email Us
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <button onClick={() => setOpen(!open)} data-testid="whatsapp-fab"
        className="w-16 h-16 rounded-full bg-emerald text-cream flex items-center justify-center shadow-xl animate-pulse-ring hover:bg-emerald-light transition-colors">
        {open ? <X className="w-7 h-7" /> : <MessageCircle className="w-7 h-7" />}
      </button>
    </div>
  );
}
